import React from 'react'
import PropTypes from 'prop-types'

import DropDownMenu from 'material-ui/DropDownMenu'
import MenuItem from 'material-ui/MenuItem'
import Styles from '../common/Styles'

const DropDownInput = ({ style, value, disabled, list, onValueChanged }) => {
  return (
    <div style={{ ...Styles.dropDownBox, ...style }}>
      <DropDownMenu
        onChange={(event, index, value) => onValueChanged(value)}
        style={styles.dropDown}
        labelStyle={styles.dropDownLabel(value)}
        value={value}
        iconButton={null}
        disabled={disabled}
        iconStyle={{ display: 'none' }}
        underlineStyle={{ display: 'none' }}>
        { list.map((status, index) =>
          <MenuItem
            key={index}
            value={status.id}
            label={status.name}
            primaryText={status.name} />)
        }
      </DropDownMenu>
      <i className='fa fa-caret-down' style={{ cursor: 'pointer' }}></i>
    </div>
  )
}

DropDownInput.defaultProps = {
  style: {}
}

DropDownInput.propTypes = {
  style: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  list: PropTypes.array.isRequired,
  onValueChanged: PropTypes.func.isRequired
}

const styles = {
  dropDown: {
    width: 125,
    height: 18
  },
  dropDownLabel: value => ({
    paddingLeft: 0,
    paddingRight: 0,
    textAlign: 'left',
    lineHeight: '18px',
    color: value === 'none' || value === 'all' ? '#9b9b9b' : '#757575'
  })
}

export default DropDownInput



// WEBPACK FOOTER //
// ./src/billing/common/DropDownInput.js